import {
  withTranslation,
} from 'react-i18next';

import LabelQuantityView from './LabelQuantityView';

const TranslatedComponent = withTranslation()(LabelQuantityView);

const Component = TranslatedComponent;

export default Component;
